var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dblWarningContainer" }, [
    _c("div", { staticClass: "dblWarning" }, [
      _c("div", { staticClass: "dblWarning__title" }, [_vm._v("解锁合盘须知")]),
      _vm._m(0),
      _c("div", { staticClass: "dblWarning__checkbox" }, [
        _c("label", { attrs: { for: "isOk" } }, [
          _c("div", { staticClass: "checkbox", class: { active: _vm.isOk } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.isOk,
                  expression: "isOk"
                }
              ],
              attrs: { type: "checkbox", id: "isOk" },
              domProps: {
                checked: Array.isArray(_vm.isOk)
                  ? _vm._i(_vm.isOk, null) > -1
                  : _vm.isOk
              },
              on: {
                change: function($event) {
                  var $$a = _vm.isOk,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.isOk = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.isOk = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.isOk = $$c
                  }
                }
              }
            }),
            _c("div", { staticClass: "checkmark" })
          ]),
          _c("div", [_vm._v("我已了解修改资料后，已购买合盘不会更新的说明。")])
        ])
      ]),
      _c("div", { staticClass: "dblWarning__btn" }, [
        _c(
          "div",
          { staticClass: "dblWarning__btn__cancel", on: { click: _vm.cancel } },
          [_vm._v("返回修改资料")]
        ),
        _c(
          "div",
          {
            staticClass: "dblWarning__btn__ok",
            class: { disabled: !_vm.isOk },
            on: { click: _vm.save }
          },
          [_vm._v("\n        确认并付款\n      ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dblWarning__content" }, [
      _c("div", [
        _vm._v(
          "\n        解锁后合盘内容将固定为当前资料，若后续修改帐户资料：\n        "
        ),
        _c("br"),
        _c("ul", [
          _c("li", [_vm._v("已购买的合盘不会更新")]),
          _c("li", [_vm._v("如需最新资料的合盘解读，需重新购买")]),
          _c("li", [_vm._v("此购买不予退款")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }